import React, { memo, forwardRef } from "react";
const SvgCapitalU = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.18 10.07c0-.293.047-.533.14-.72.093-.187.2-.333.32-.44a.938.938 0 01.42-.2c.146-.04.273-.06.38-.06.107 0 .233.02.38.06.146.027.28.093.4.2.133.107.247.253.34.44.093.187.14.427.14.72v7.72c0 .853-.147 1.627-.44 2.32a5.202 5.202 0 01-1.2 1.74 5.408 5.408 0 01-1.8 1.12 6.538 6.538 0 01-2.26.38 6.538 6.538 0 01-2.26-.38 5.637 5.637 0 01-1.82-1.12 5.202 5.202 0 01-1.2-1.74c-.28-.693-.42-1.467-.42-2.32v-7.72c0-.293.046-.533.14-.72.093-.187.2-.333.32-.44a.938.938 0 01.42-.2c.146-.04.273-.06.38-.06.106 0 .233.02.38.06.146.027.28.093.4.2.133.107.246.253.34.44.093.187.14.427.14.72v7.62c0 .413.053.827.16 1.24.106.4.28.76.52 1.08.253.32.58.58.98.78.413.2.92.3 1.52.3s1.1-.1 1.5-.3c.413-.2.74-.46.98-.78.253-.32.433-.68.54-1.08.107-.413.16-.827.16-1.24v-7.62z"
      />
    </svg>
  );
});
SvgCapitalU.displayName = "SvgCapitalU";
const MemoForwardRef = memo(SvgCapitalU);
export default MemoForwardRef;
